import { render, staticRenderFns } from "./deliverDetail.vue?vue&type=template&id=a0878eda&scoped=true&"
import script from "./deliverDetail.vue?vue&type=script&lang=js&"
export * from "./deliverDetail.vue?vue&type=script&lang=js&"
import style0 from "./deliverDetail.vue?vue&type=style&index=0&id=a0878eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0878eda",
  null
  
)

export default component.exports